import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { withTranslation } from "react-i18next";
import LibraryCycleProgram from "./library-cycle-program";
import submit from "submit-form";
import { STRIPE } from "../../constants";
import getCycleCardImagePath from "../../utils/get-cycle-card-image-path";
import getCycleCardAuthor from "../../utils/get-cycle-card-author-name";
import ImgComponent from "../ImgComponent";
import SvgIcon from "../SvgIcon";
import { RillContext } from "../../rill/RillReact/share/base";

const dragula = process.browser && require("react-dragula");

// Used in program library and program-builder landing page
class LibraryCycleCard extends React.Component {
  constructor() {
    super();
    this.state = {
      imgError: false,
    };
    this.imageerror = this.imageerror.bind(this);
  }
  initDND() {
    if (
      !this.refs.programs ||
      get(this.refs, "programs.children", []).length < 2
    )
      return;
    let from = null,
      cycleId;

    this.programs = dragula([this.refs.programs], {
      revertOnSpill: true,
    });

    this.programs.on("drag", handleDrag);
    this.programs.on("drop", handleDrop);

    this.setState({ drake: this.programs });
    const self = this;
    function handleDrag(el, source) {
      from = Array.from(source.childNodes).indexOf(el);
      cycleId = source.getAttribute("data-cycleId");
    }

    function handleDrop(el, target, source, sibling) {
      const to = Array.from(el.parentNode.childNodes).indexOf(el);
      const destinationCycleId = el.parentNode.getAttribute("data-cycleId");

      if (destinationCycleId !== cycleId) return; //cancel drag

      if (from !== to && to >= 0) {
        // 	// submit(`/actions/cycle/programs/move/${from + 1}/${to + 1}/${cycleId}`);
        self.setState({ rerender: true });
        submit("/actions/cycle/programs/reorder", {
          method: "POST",
          body: {
            cycle: cycleId,
            order: map(target.children, (el) => el.getAttribute("data-order")),
            // from: from + 1,
            // to: to + 1
          },
        });
      }
    }
  }

  stopDND() {
    this.programs && this.programs.destroy();
  }
  imageerror() {
    this.setState({ imgError: true });
  }
  componentDidMount() {
    this.initDND();
  }
  componentWillUnmount() {
    this.stopDND();
  }

  render() {
    const { cycle, cardIndex, isOwnCycle, t } = this.props;
    const { activeUser, activeUserToRequest } = this.context.locals;

    const image = getCycleCardImagePath(cycle);
    const authorName = getCycleCardAuthor(cycle);

    const style = cycle.type === "premium" ? "alt-premium" : "alt-mine";

    // Don't allow standard users to schedule premium programs
    const userPlan = get(activeUserToRequest, "stripe.plan", "");
    const isPremium =
      userPlan === STRIPE.PLANS.V2.premiumMonthly ||
      userPlan === STRIPE.PLANS.V2.premiumAnnually;
    const isAdmin = activeUser.permissions?.includes("admin");
    const isAmbassador = activeUser.permissions?.includes("ambassador");
    const suggestUpradePath = "/actions/refresh?modal[type]=suggest-upgrade";
    const addToCalendarPath = `/actions/refresh?modal[type]=add-to-calendar&cycleId=${cycle._id}&wholeCycle=true`;

    return (
      <article className="column" data-col="1/3">
        <div className={`Cycle-Builder-Preview ${style} program-library-card`}>
          <div
            className={`image${this.state.imgError ? " error" : ""}`}
            onClick={() => {
              submit(`/actions/refresh/?`, {
                method: "GET",
                body: {
                  "modal[type]": "learn-more",
                  cycleId: cycle._id,
                },
              });
            }}
          >
            <ImgComponent
              image={image}
              classNames={`program-image ${
                image.startsWith("data:image") ? "no-image" : ""
              }`}
              altText="program thumbnail"
              onErrorFn={this.imageerror}
            />
          </div>
          <a
            href={
              cycle.type === "premium" &&
              !isPremium &&
              !isAdmin &&
              !isAmbassador
                ? suggestUpradePath
                : addToCalendarPath
            }
            role="button"
            data-button-type="secondary"
            className="m-4 gap-2"
          >
            <SvgIcon src="/img/new-icons/calendar-ico.svg" />
            {t("libraryCycleCard.addToCalendar")}{" "}
          </a>
          <div className="details">
            <header>
              <h2 className="title">{cycle.name}</h2>
            </header>
            <ul className="programs">
              {cycle.programs.map((program, programIndex) => {
                return (
                  <LibraryCycleProgram
                    key={programIndex}
                    program={program}
                    cycle={cycle}
                    programIndex={programIndex}
                    cardIndex={cardIndex}
                    rerender={this.state.rerender}
                    isPremium={isPremium}
                    isAdmin={isAdmin}
                    isAmbassador={isAmbassador}
                  />
                );
              })}
            </ul>
          </div>
        </div>
      </article>
    );
  }
}

LibraryCycleCard.contextType = RillContext;

export default withTranslation("coaching-portal")(LibraryCycleCard);
